module.exports = "0x3B36735cA56Ac5dc91E60a1fCA2237295BAB0eFB"


// WEBPACK FOOTER //
// ./src/contracts/Cryptogs.3.address.js